const Footer = () => {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-gray-900 text-gray-400">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <img
              src="https://static.readdy.ai/image/af629f12c2092b190a665b44ca157be0/2a1f8fc981b3a3b70bdb589812f4ada4.jpeg"
              alt="Elite Drainage Services"
              className="h-12 w-auto object-contain rounded-md mb-4"
            />
            <p className="text-sm leading-relaxed mb-5">
              Professional drainage maintenance plans for homeowners and commercial properties across South &amp; South West England.
            </p>
            <div className="flex gap-3">
              {['ri-facebook-fill', 'ri-twitter-x-fill', 'ri-instagram-line', 'ri-linkedin-fill'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center bg-gray-800 hover:bg-orange-500 rounded-lg transition-colors cursor-pointer"
                >
                  <i className={`${icon} text-sm text-gray-400 hover:text-white`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Plans */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-widest mb-4">
              <a href="#plans">Coverage Plans</a>
            </h4>
            <div className="w-8 h-0.5 bg-orange-500 mb-5"></div>
            <ul className="flex flex-col gap-3">
              {[
                { label: 'Monthly Plan', id: 'pricing' },
                { label: 'All-In-One Plan', id: 'pricing' },
                { label: 'Commercial Cover', id: 'plans' },
                { label: 'Compare Plans', id: 'pricing' },
              ].map((item) => (
                <li key={item.label}>
                  <button
                    onClick={() => scrollTo(item.id)}
                    className="text-sm hover:text-orange-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-widest mb-4">
              <a href="#benefits">Services</a>
            </h4>
            <div className="w-8 h-0.5 bg-orange-500 mb-5"></div>
            <ul className="flex flex-col gap-3">
              {['Emergency Callout', 'CCTV Surveys', 'Drain Jetting', 'Pipe Repairs', 'Soakaway Installation', 'Drain Relining'].map((s) => (
                <li key={s}>
                  <button
                    onClick={() => scrollTo('benefits')}
                    className="text-sm hover:text-orange-400 transition-colors cursor-pointer"
                  >
                    {s}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-widest mb-4">
              <a href="#contact">Get In Touch</a>
            </h4>
            <div className="w-8 h-0.5 bg-orange-500 mb-5"></div>
            <div className="flex flex-col gap-4">
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-phone-line text-orange-400 text-sm"></i>
                </div>
                <div>
                  <div className="text-white font-semibold text-sm">08000487055</div>
                  <div className="text-xs mt-0.5">Mon–Fri 8am–6pm</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-alarm-warning-line text-orange-400 text-sm"></i>
                </div>
                <div>
                  <div className="text-white font-semibold text-sm">08000487055</div>
                  <div className="text-xs mt-0.5">24/7 Emergency Line</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-mail-line text-orange-400 text-sm"></i>
                </div>
                <div>
                  <a href="mailto:info@elitedrain-services.com" className="text-orange-400 text-sm hover:underline">
                    info@elitedrain-services.com
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-orange-400 text-sm"></i>
                </div>
                <div className="text-xs leading-relaxed">
                  South &amp; South West England<br />
                  Bristol, Bournemouth, Southampton
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Legal Company Info */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-5">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-3">
            <p className="text-xs text-gray-500">
              &copy; {new Date().getFullYear()} Elite Drainage Services Ltd. Registered in England &amp; Wales. Registered Office: South &amp; South West England. This is a service agreement, not an insurance policy.
            </p>
            <div className="flex flex-wrap gap-4">
              <a href="/terms" className="text-xs text-gray-500 hover:text-orange-400 transition-colors cursor-pointer">Terms &amp; Conditions</a>
              <a href="/complaints" className="text-xs text-gray-500 hover:text-orange-400 transition-colors cursor-pointer">Complaints</a>
              <a href="#" rel="nofollow" className="text-xs text-gray-500 hover:text-orange-400 transition-colors">Privacy Policy</a>
              <a href="#" rel="nofollow" className="text-xs text-gray-500 hover:text-orange-400 transition-colors">Cookie Policy</a>
            </div>
          </div>
          <p className="text-xs text-gray-600">
            Cover subject to exclusions, claim limits (£2,000 per claim / £10,000 annually), fair usage policy, and 30-day waiting period. UK Mainland only.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
